export const ACCOUNT_DECLINED_REASON = {
  doNotHave: 'do_not_have',
  doNotWant: 'do_not_want',
  other: 'other',
} as const;
